import { BaseModel } from "./base";
import { MinUserObj, Parent } from "./document";
import { UserMinumum } from "./user";

export type AccessLevel='VIEWER'|'WRITER'|'OWNER'|'EXTERNAL_VIEWER'|'EXTERNAL_WRITER'
export class AssetAccess extends BaseModel {
    createdBy : MinUserObj = new MinUserObj();
    updatedBy : MinUserObj = new MinUserObj();
    user : MinUserObj = new MinUserObj();
    asset : Parent = new Parent();
    userIds : string[] = [];
    access : AccessLevel = 'WRITER';
    notify : boolean = false;
    note : string = null;
    url: string = null;

}